import { Button, Form, Input } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";

function VerifyOtp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      dispatch(showLoading());
      const response = await axios.post("/api/user/verify-otp", values);
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        toast("Redirecting to Login Page");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    }
  };

  return (
    <div className="auth">
      <div className="auth-bg">
        <h1 className="card-t">OTP Verification</h1>
        <div className="auth-form card p-3">
          <h3 className="card-title">Enter the OTP sent to your email</h3>
          <Form layout="vertical" onFinish={onFinish}>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input your E-mail!",
                },
              ]}
            >
              <Input placeholder="Email Address" />
            </Form.Item>

            <Form.Item
              name="otp"
              label="OTP"
              rules={[
                {
                  required: true,
                  message: "Please input the OTP!",
                },
              ]}
            >
              <Input placeholder="OTP" />
            </Form.Item>

            <Button className="btn-primary mt-3" htmlType="submit">
              Verify OTP
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default VerifyOtp;
